import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { clearSession, getStoredUser } from "../utils/authSession";

export default function Header() {
  const [open, setOpen] = useState(false);
  const [user, setUser] = useState(null);
  const navigate = useNavigate();

  // Load user on mount + react to cross‑tab changes
  useEffect(() => {
    const loadUser = () => {
      setUser(getStoredUser());
    };

    loadUser();

    const onStorage = (e) => {
      if (!e.key || e.key === "user") loadUser();
    };
    window.addEventListener("storage", onStorage);
    window.addEventListener("user-changed", loadUser);

    return () => {
      window.removeEventListener("storage", onStorage);
      window.removeEventListener("user-changed", loadUser);
    };
  }, []);

  const handleLogout = () => {
    clearSession();
    setUser(null);
    navigate("/");
  };

  const closeMenu = () => setOpen(false);

  useEffect(() => {
    document.body.classList.toggle("cl-nav-lock", open);
    return () => document.body.classList.remove("cl-nav-lock");
  }, [open]);

  useEffect(() => {
    const onResize = () => {
      if (window.innerWidth > 1200) setOpen(false);
    };
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  const authButtons = user ? (
    <>
      <Link className="btn btn-outline" to="/admin/dashboard" onClick={closeMenu}>
        Dashboard
      </Link>
      <button className="btn btn-solid" onClick={handleLogout}>
        Logout
      </button>
    </>
  ) : (
    <Link className="btn btn-outline" to="/login" onClick={closeMenu}>
      Login
    </Link>
  );

  return (
    <header className={`cl-header${open ? " is-open" : ""}`}>
      <div className="cl-container cl-header-inner">
        <Link to="/" className="cl-logo" onClick={closeMenu}>
          Click <span>Law</span>
        </Link>

        <nav className={`cl-nav ${open ? "open" : ""}`}>
          <Link to="/" onClick={closeMenu}>Home</Link>
          <Link to="/#about" onClick={closeMenu}>About Us</Link>
          <Link to="/plans/personal" onClick={closeMenu}>Services</Link>
          <Link to="/contact" onClick={closeMenu}>Contact Us</Link>
          <div className="cl-nav-auth">{authButtons}</div>
        </nav>

        <div className="cl-actions">
          <div className="cl-actions-auth">{authButtons}</div>
          <button
            className="cl-burger"
            aria-label="Menu"
            aria-expanded={open}
            onClick={() => setOpen((v) => !v)}
          >
            ☰
          </button>
        </div>
      </div>
    </header>
  );
}
